import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/services/authentication.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  values: string[];
  constructor(private authenticationService: AuthenticationService,private _router:Router){}
  ngOnInit() {
    if(this.authenticationService.currentUserValue){
    const currentUser = this.authenticationService.currentUserValue['user'];
    if(currentUser !==null && currentUser.role !==null){
      if(currentUser.role.name === 'Interviewer'){
        this._router.navigate(['/dashboard'])
      } 
      else if(currentUser.role.name === 'Recruiter'){
        this._router.navigate(['/dashboard'])
      }else if(currentUser.role.name === 'SuperAdmin' || currentUser.role.name === 'HRAdmin'){
        this._router.navigate(['/dashboard'])
      } else {
        this._router.navigate(['/login'])
      }
    }
    
  }
}
}
